import { render, staticRenderFns } from "./auth-base-signup.vue?vue&type=template&id=7d7f6060&scoped=true&"
import script from "./auth-base-signup.vue?vue&type=script&lang=ts&"
export * from "./auth-base-signup.vue?vue&type=script&lang=ts&"
import style0 from "./auth-base-signup.vue?vue&type=style&index=0&id=7d7f6060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f6060",
  null
  
)

export default component.exports